import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import SiteLayout from "./components/SiteLayout";
import AboutPage from "./pages/AboutPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminContactsPage from "./pages/AdminContactsPage";
import AdminVolunteersPage from "./pages/AdminVolunteersPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import ContactPage from "./pages/ContactPage";
import EventsPage from "./pages/EventsPage";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import MissionSupportersPage from "./pages/MissionSupportersPage";
import ProgramsPage from "./pages/ProgramsPage";
import SupportPage from "./pages/SupportPage";
import "./App.css";

const isAdminAuthenticated = () => localStorage.getItem("fvg-admin-auth") === "true";

function AdminRoute({ children }) {
  if (!isAdminAuthenticated()) {
    return (
      <Navigate
        to="/admin/login"
        replace
      />
    );
  }
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route
              path="/"
              element={<HomePage />}
            />
            <Route
              path="/about"
              element={<AboutPage />}
            />
            <Route
              path="/programs"
              element={<ProgramsPage />}
            />
            <Route
              path="/events"
              element={<EventsPage />}
            />
            <Route
              path="/events/:eventId"
              element={<EventsPage />}
            />
            <Route
              path="/contact"
              element={<ContactPage />}
            />
            <Route
              path="/support"
              element={<SupportPage />}
            />
            <Route
              path="/mission-supporters"
              element={<MissionSupportersPage />}
            />
            <Route
              path="/admin/login"
              element={<AdminLoginPage />}
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminDashboardPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/messages"
              element={
                <AdminRoute>
                  <AdminContactsPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/volunteers"
              element={
                <AdminRoute>
                  <AdminVolunteersPage />
                </AdminRoute>
              }
            />
            <Route
              path="*"
              element={<NotFoundPage />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
